import React from 'react'
import Icon from './icon'
import { classnames } from '../../helpers'
import './style.scss'

const CheckBox = ({ label, onChange, ...props }) => {
  const [checked, setChecked] = React.useState(false)

  const handleToggle = React.useCallback(() => {
    if (onChange) {
      onChange(!checked)
    }
    setChecked(!checked)
  }, [onChange, checked])

  return (
    <div className="checkbox-wrapper" onClick={handleToggle} {...props}>
      <div className={classnames({ icon: true, checked })}><Icon checked={checked} /></div>
      <span className="checkbox-label">{label}</span>
    </div>
  )
}

export default CheckBox
